/**
 * Medição do carregamento do Painel de Pedidos.
 *
 * Existe porque "a tela demora pra entrar" não é diagnosticável de fora: o caminho até
 * o primeiro pedido na tela passa por login, uma chamada HTTP ao backend, duas consultas
 * de permissão no Firestore e dois listeners de pedidos — e qualquer um deles pode ser o
 * lento, inclusive de forma intermitente (backend que hiberna, rede do lojista, volume de
 * pedidos da semana). Sem número por etapa, a conversa vira chute.
 *
 * Custo: um Date.now() por etapa e UMA tabela no console ao final. Nada é enviado para
 * lugar nenhum — é só para abrir o console (F12) e ler.
 *
 * Uso no console do navegador:
 *   __auuiiPerf()  → reimprime a tabela da carga atual
 */

const T0 = Date.now();
const marcos = [];
let jaImprimiu = false;

/** Registra uma etapa do carregamento. `detalhe` aceita qualquer dado útil (contagem, status). */
export function marco(nome, detalhe) {
  marcos.push({ nome, ms: Date.now() - T0, detalhe });
}

/** Imprime a tabela com o tempo de cada etapa e o intervalo entre elas. */
export function imprimirResumo(motivo = '') {
  if (typeof console === 'undefined' || marcos.length === 0) return;
  let anterior = 0;
  const linhas = marcos.map((m) => {
    const desde = m.ms - anterior;
    anterior = m.ms;
    return {
      etapa: m.nome,
      'desde o início (s)': (m.ms / 1000).toFixed(2),
      'gasto nesta etapa (s)': (desde / 1000).toFixed(2),
      detalhe: m.detalhe === undefined ? '' : m.detalhe,
    };
  });

  const total = marcos[marcos.length - 1].ms / 1000;
  console.groupCollapsed(
    `⏱️ Carregamento do painel: ${total.toFixed(2)}s${motivo ? ` (${motivo})` : ''} — clique para abrir`
  );
  console.table(linhas);
  // A etapa mais cara é a resposta que interessa; destacada para não precisar ler a tabela.
  const maior = linhas.reduce((a, b) =>
    parseFloat(b['gasto nesta etapa (s)']) > parseFloat(a['gasto nesta etapa (s)']) ? b : a
  );
  console.info(`👉 Etapa mais lenta: "${maior.etapa}" (${maior['gasto nesta etapa (s)']}s)`);
  console.groupEnd();
}

/** Imprime uma única vez por carga — chamado quando os pedidos aparecem na tela. */
export function imprimirResumoUmaVez(motivo) {
  if (jaImprimiu) return;
  jaImprimiu = true;
  imprimirResumo(motivo);
}

if (typeof window !== 'undefined') {
  window.__auuiiPerf = () => imprimirResumo('reimpressão manual');
}

marco('app:carregou o javascript');
